import { Component, OnInit } from '@angular/core';
import {InformationDataService} from "../../information/InformationDataService";
import {Information} from "../../information/information";
import {DmesglogDataService} from "../dmesglogDataService";
import {DMESGLOG, DMESGLOG_ROOT} from "../dmesglogData";

@Component({
  selector: 'app-dmesglog',
  templateUrl: './dmesglog.component.html',
  styleUrls: ['./dmesglog.component.css']
})
export class DmesglogComponent implements OnInit {
  dmesglog: DMESGLOG[] | undefined;

  constructor(private dmesglogDataService: DmesglogDataService) {

  }


  ngOnInit(): void {
    this.dmesglogDataService.GetData().subscribe({
      next: dmesglogroot => {
        this.dmesglog = dmesglogroot.DMESG_LOG;
      }
    });
  }


}
